'use client'

import { GlobalPageHeaderLogo } from '@/components/layout/global/GlobalPageHeaderLogo'
import { HamburgerNavMenu } from '@/components/ui/HamburgerNavMenu'
import { useUserProfile } from '@/hooks/business/useUserProfile'
import { ClockTimestampFormatter } from '@/components/utils/clock/ClockTimestampFormatter'
import { cn } from '@/lib/utils'
import { ReactNode } from 'react'

export type GlobalPageHeaderProps = {
  navMenuItems?: ReactNode
  className?: string
}

export function GlobalPageHeader({ navMenuItems, className }: GlobalPageHeaderProps) {
  const profile = useUserProfile()
  return (
    <header
      className={cn(
        'grid h-10 grid-cols-3 items-center bg-white drop-shadow sm:h-12 lg:h-16 dark:bg-[#4A4A4A]',
        className
      )}
    >
      <div className="z-10 justify-self-start pl-5">
        <HamburgerNavMenu
          classNames={{ container: 'static', popup: 'left-3 right-3.5 top-0 sm:top-2 lg:w-80' }}
        >
          {navMenuItems}
        </HamburgerNavMenu>
      </div>
      <div className="relative h-full py-0.5">
        <GlobalPageHeaderLogo />
      </div>
      <div
        className={cn(
          'invisible sm:visible',
          'flex h-[inherit] flex-row justify-self-end',
          'bg-gradient-to-b from-[#01A4FF] from-[.49%] to-[#1757AF] to-[99.51%]',
          'overflow-hidden'
        )}
      >
        <svg
          viewBox="326 46 131 67"
          className="-ml-1 -mt-0.5 h-[110%] flex-none fill-white lg:h-[103%] dark:fill-[#4A4A4A]"
          preserveAspectRatio="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M -299.214 46.104 L -299.214 114.296 L 335.691 114.296 C 349.452 114.115 358.266 111.969 373.77 100.37 L 425.06 60.03 C 440.282 48.431 449.095 46.285 463.139 46.104 L -299.214 46.104 Z"
          />
        </svg>
        <ClockTimestampFormatter
          template="hh:mm A"
          className={cn(
            'relative right-3 w-24 self-center justify-self-center md:-left-3 lg:right-5 lg:w-32',
            'whitespace-nowrap text-center text-2xl font-medium text-white sm:text-lg lg:text-2xl'
          )}
        />
        {profile?.id !== undefined && (
          <p id="dynatrace-agent-id" className="hidden">
            {profile.id}
          </p>
        )}
      </div>
    </header>
  )
}
